import type { HTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

interface GmSectionProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
}

export const GmSection = ({ children, title, className, ...args }: GmSectionProps) => {
  return (
    <section className={cn('flex flex-col gap-3', className)} {...args}>
      <h2
        data-section-title
        className="text-sm font-semibold leading-5 text-white md:text-base"
      >
        {title}
      </h2>
      {children}
    </section>
  );
};
